import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Typography } from '../../../../components/Wrappers/Wrappers';
import CtaButton from '../../../../commons/ctaButton';
import { useStyles } from './integrationsSection.styles';
import Logo from './Logo';
import IntegrationDetailsDialog from './IntegrationDetailsDialog';

function IntegrationCard ({ integration }) {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const { name, category, subtitle } = integration;

    return (
        <div className={classes.card}>
            <div className={classes.cardTop}>
                <Logo integration={integration} />
                {category && <span className={classes.cardCat}>{category}</span>}
            </div>

            <div>
                <Typography variant="body2" weight="bold" className={classes.cardName}>{name}</Typography>
                <Typography variant="body2" className={classes.cardDesc}>{subtitle}</Typography>
            </div>

            <CtaButton
                kind="secondary"
                className={classes.cardCta}
                onClick={() => setOpen(true)}
            >
                More details
            </CtaButton>

            <IntegrationDetailsDialog
                integration={integration}
                open={open}
                onClose={() => setOpen(false)}
            />
        </div>
    );
}

IntegrationCard.propTypes = {
    integration: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
        category: PropTypes.string,
        description: PropTypes.string,
        logo: PropTypes.string,
        initials: PropTypes.string,
        subtitle: PropTypes.string,
        summary: PropTypes.string,
        features: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
};

export default IntegrationCard;
